export default __webpack_public_path__ + "media/faq/faq_engraving_screenshot_2-3b6771bb.png";